/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({ width, height, color, ...restProps }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2ZM12.5 18C12.7761 18 13 17.7761 13 17.5V10C13 9.72386 12.7761 9.5 12.5 9.5C12.2239 9.5 12 9.72386 12 10V17.5C12 17.7761 12.2239 18 12.5 18ZM13.5 7C13.5 6.44771 13.0523 6 12.5 6C11.9477 6 11.5 6.44771 11.5 7C11.5 7.55229 11.9477 8 12.5 8C13.0523 8 13.5 7.55229 13.5 7Z"
      fill={color}
    />
  </svg>
)

Icon.defaultProps = {
  width: '25',
  height: '24',
  color: '#737373',
}
Icon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

export default Icon
